module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": ""
    }
  }, [_c('h2', {
    staticClass: "mb-3"
  }, [_vm._v("Sem permissão")]), _vm._v(" "), _c('p', {
    staticClass: "mb-4"
  }, [_vm._v("Você não tem acesso a esta área.")]), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "to": {
        name: 'ImoveisRoot'
      }
    }
  }, [_vm._v("Voltar para Imóveis")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-313e1564"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Utils/Forbidden.vue
// module id = 1002
// module chunks = 1